import registration_application from "../../data/guides/en/registration_application.md";
import uom_register from "../../data/guides/en/uom_register.md";
import institutional_account from "../../data/guides/en/institutional_account.md";
import academic_email_activation from "../../data/guides/en/academic_email_activation.md";
import academic_id from "../../data/guides/en/academic_id.md";
import eudoxus_books from "../../data/guides/en/eudoxus_books.md";
import library_registration from "../../data/guides/en/library_registration.md";
import open_eclass from "../../data/guides/en/open_eclass.md";
import boarding from "../../data/guides/en/boarding.md";
import housing from "../../data/guides/en/housing.md";
import healthcare from "../../data/guides/en/healthcare.md";

export default {
  registration_application_guide: registration_application,
  uom_register_guide: uom_register,
  institutional_account_guide: institutional_account,
  academic_email_activation_guide: academic_email_activation,
  academic_id_guide: academic_id,
  eudoxus_books_guide: eudoxus_books,
  library_registration_guide: library_registration,
  open_eclass_guide: open_eclass,
  boarding_guide: boarding,
  housing_guide: housing,
  healthcare_guide: healthcare,
  return_to_guides_list: "Return to guides list",
  registration_application_title:
    "Registration application for successful candidates",
  uom_register_title: "Login to the UoM Register page",
  institutional_account_title: "Institutional account",
  academic_email_activation_title: "Activate academic email",
  academic_id_title: "Academic ID",
  eudoxus_books_title: "Books from Eudoxus",
  library_registration_title: "Library registration",
  open_eclass_title: "Open eClass registration",
  boarding_title: "Boarding",
  housing_title: "Housing",
  healthcare_title: "Healthcare",
};
